import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import cn from 'classnames';
import { useTranslation } from 'next-i18next';
import IconWrapper from '@components/ui/Icons';
import Heading from '../../ui/Heading';
import styles from './CardLink.module.scss';

export interface CardLinkProps {
  link: string;
  imageUrl: string;
  imageAlt: string;
  date?: string;
  title: string;
  excerpt: string;
  hasBorder?: boolean;
  classNames?: string | string[];
}

const CardLink = ({
  link,
  imageUrl,
  imageAlt,
  date,
  title,
  excerpt,
  hasBorder,
  classNames,
}: CardLinkProps) => {
  const rootClassNames = cn(styles.cardLink, classNames, {
    [styles.cardLinkBorder]: hasBorder,
  });
  const { t } = useTranslation(['common']);

  return (
    <li className={rootClassNames}>
      <Link href={`${link}`} className={styles.cardContentContainer}>
        {imageUrl && (
          <div className={styles.cardImage}>
            <Image
              src={imageUrl}
              alt={imageAlt || title}
              fill
              sizes="(min-width: 480px) 300px, 400px"
            />
          </div>
        )}
        {date && <p className={styles.date}>{date}</p>}
        <div className={styles.cardContent}>
          <div>
            <Heading semanticLevel="h4" styleLevel="5">
              {title}
            </Heading>
            <p>{excerpt}</p>
          </div>
          <span>
            {t('common:cardlink.readmore')}
            <IconWrapper
              icon="caret-right"
              height={11}
              classNames={styles.readMoreIcon}
            />
          </span>
        </div>
      </Link>
    </li>
  );
};

export default CardLink;
